"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Headlines() {
  const {
    ref: ruleRef,
    isVisible: ruleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="10768" id="front-page-headlines" className="dark bg-background text-foreground py-16 md:py-24 font-default">
      <div className="max-w-[1440px] mx-auto px-6 md:px-14">
        {}
        <div ref={ruleRef} className="h-px w-full bg-foreground origin-left transition-transform duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)]" style={{
        transform: ruleVisible ? "scaleX(1)" : "scaleX(0)"
      }} aria-hidden="true" />

        {}
        <div className="grid grid-cols-12 gap-4 md:gap-6 pt-4 pb-10 md:pb-16 transition-all duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)]" style={{
        opacity: ruleVisible ? 1 : 0,
        transform: ruleVisible ? "translateY(0)" : "translateY(12px)",
        transitionDelay: ruleVisible ? "200ms" : "0ms"
      }}>
          <div className="col-span-7 md:col-span-3">
            <span className="font-mono text-[0.6875rem] md:text-xs font-medium uppercase tracking-[0.12em] text-foreground">
              {"FEATURE / COMMUNITY"}
            </span>
          </div>
          <div className="hidden md:block md:col-span-6" aria-hidden="true" />
          <div className="col-span-5 md:col-span-3 text-right">
            <span className="font-mono text-[0.6875rem] md:text-xs font-normal tracking-[0.04em] text-muted-foreground">
              {"20 MAY 2024 — 8 MIN READ"}
            </span>
          </div>
        </div>

        {}
        <div className="grid grid-cols-12 gap-6 md:gap-6">
          {}
          <div ref={imageRef} className="col-span-12 md:col-span-7 transition-all duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)]" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(12px)",
          transitionDelay: imageVisible ? "260ms" : "0ms"
        }}>
            <div className="relative overflow-hidden aspect-[3/2] group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/community_voices_report.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/community_voices_report.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1711113/img/community_voices_report.png-wvc-sizes" alt="Diverse community members engaging in a town hall discussion" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[350ms] ease-[cubic-bezier(0.2,0.7,0.2,1)] group-hover:scale-[1.02]" />
            </div>
          </div>

          {}
          <div ref={headlineRef} className="col-span-12 md:col-span-5 flex flex-col">
            <h1 className="font-default font-medium text-foreground transition-all duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)]" style={{
            fontSize: "clamp(2.75rem, 5.6vw, 5.5rem)",
            letterSpacing: "-0.025em",
            lineHeight: 0.98,
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(8px)",
            transitionDelay: headlineVisible ? "320ms" : "0ms"
          }}>
              {"Amplifying the stories that shape our collective future"}
            </h1>

            <p className="mt-6 md:mt-8 font-default font-normal text-muted-foreground transition-all duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)]" style={{
            fontSize: "clamp(1.125rem, 1.2vw, 1.3125rem)",
            letterSpacing: "-0.005em",
            lineHeight: 1.5,
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(12px)",
            transitionDelay: headlineVisible ? "440ms" : "0ms"
          }}>
              {"Inclusive Voices News is dedicated to unbiased reporting that bridges divides and empowers every member of our community."}
            </p>

            <div className="mt-8 md:mt-10 transition-all duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)]" style={{
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(12px)",
            transitionDelay: headlineVisible ? "560ms" : "0ms"
          }}>
              <Link to="/OurStoryPage" className="group inline-flex items-center gap-2 text-foreground text-base font-default">
                <span className="relative">
                  {"Read our mission"}
                  <span className="absolute left-0 right-0 -bottom-0.5 h-px bg-border transition-all duration-[180ms] ease-[cubic-bezier(0.2,0.7,0.2,1)] group-hover:bg-[var(--chart-1)] group-hover:h-[1.5px]" aria-hidden="true" />
                </span>
                <ArrowUpRight className="size-4 transition-colors duration-[180ms] group-hover:text-[var(--chart-1)]" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}